module.exports = __webpack_public_path__ + "img/feature_05.fb312531.jpg";